import { Controller } from "@hotwired/stimulus"
import { post, get } from "@rails/request.js"

export default class extends Controller {
  static targets = ["cell"]
  static values = {
    toggleUrl: String,
    editUrl: String,
    reservationUrl: String
  }

  // Handle click on a date cell
  // Single click = open edit modal
  // Shift+click = quick toggle availability
  cellClick(event) {
    const cell = event.currentTarget
    const date = cell.dataset.date

    if (event.shiftKey) {
      // Shift+click: quick toggle single date
      this.toggleSingleDate(date)
    } else if (cell.dataset.reserved === "true") {
      // Reserved date: open reservation details modal
      this.openReservationModal(cell.dataset.reservationId)
    } else {
      // Normal click: open edit modal
      this.openDateModal(date)
    }
  }

  // Open modal for single date editing
  async openDateModal(date) {
    const url = this.editUrlValue.replace(":date", date)
    const response = await get(url, {
      responseKind: "turbo-stream"
    })

    if (!response.ok) {
      console.error("Error opening date modal:", response)
    }
  }

  // Open reservation details modal
  async openReservationModal(id) {
    const url = this.reservationUrlValue.replace(":id", id)
    const response = await get(url, {
      responseKind: "turbo-stream"
    })

    if (!response.ok) {
      console.error("Error opening reservation modal:", response)
    }
  }

  // Quick toggle single date availability
  async toggleSingleDate(date) {
    const response = await post(this.toggleUrlValue, {
      body: JSON.stringify({ date: date }),
      contentType: "application/json",
      responseKind: "turbo-stream"
    })

    if (!response.ok) {
      console.error("Error toggling date:", response)
    }
  }
}
